/**
 * Re-export `themeGet` to make it ES module compatible.
 */
import { default as _themeGet } from "@styled-system/theme-get";
export var themeGet = _themeGet["default"] || _themeGet;